import OurProductsPage from '@modules/professional/page/OurProductsPage';
import type { MetaDescriptor } from '@remix-run/node';
import { loader } from '@modules/professional/page/loaders/our-products-page-loader.server';
import type { PreviewDisabledFeatures } from '@modules/root/hook/use-is-disabled-in-preview';
import { mergeMeta } from '~/modules/seo';
import type { APHandle } from '~/modules/root';

export const meta = mergeMeta<typeof loader>(
    () => {
        return [];
    },
    () => {
        const preloadImageLinks: MetaDescriptor[] = [];
        return [...preloadImageLinks];
    },
);

const disabledInPreview: PreviewDisabledFeatures = {
    featured_tile_links: false,
};

export const handle: APHandle = {
    category: 'product',
    disabledInPreview,
};

export { loader };
export default OurProductsPage;
